import { BarsLogo } from "./Logo";

export default function LoadingScreen({ label, fullscreen = true }) {
  return (
    <div
      className={`${fullscreen ? "fixed inset-0 z-[500]" : "w-full h-full"} flex flex-col items-center justify-center bg-[#0A0A0A]`}
      data-testid="loading-screen"
    >
      <BarsLogo size={56} color="#EDEDED" animated />
    </div>
  );
}

// Compact inline loader — replaces Loader2/animate-spin throughout the app
export function CrescLoader({ size = 20, color = "#EDEDED" }) {
  return <BarsLogo size={size} color={color} animated />;
}
